import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e0c96b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-box" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "d-lg-flex d-md-inline d-sm-inline p-3 align-items-start justify-content-around card-items-box" }
const _hoisted_4 = { class: "d-flex flex-column justify-content-between align-items-center card-item" }
const _hoisted_5 = { class: "d-flex justify-content-center align-items-center description-box" }
const _hoisted_6 = { class: "item-text" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-center input-box"
}
const _hoisted_8 = ["value", "onInput"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "fs13" }, "m²", -1))
const _hoisted_10 = {
  key: 1,
  class: "d-flex justify-content-center input-box"
}
const _hoisted_11 = ["value", "onInput"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "fs13" }, "m²", -1))
const _hoisted_13 = { class: "item-text" }
const _hoisted_14 = { class: "d-flex justify-content-around align-items-center" }
const _hoisted_15 = {
  key: 0,
  class: "d-flex flex-column align-items-center"
}
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = { class: "item-text" }
const _hoisted_18 = {
  class: "d-flex justify-content-center input-box",
  style: {"margin-top":"-2px","margin-left":"-5px"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { style: {"font-size":"14px"} }, "R$", -1))
const _hoisted_20 = {
  key: 1,
  style: {"font-size":"14px"}
}
const _hoisted_21 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass({
          'card-item-container': !_ctx.isIndirectCoasts,
          'indirect-item-container': _ctx.isIndirectCoasts,
          'divider': index < _ctx.items.length-1 && item.description !== 'Média m² na região',
          'divider-ground': _ctx.isGroundCoasts && (item.description === 'Permuta')
        })
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h6", _hoisted_6, _toDisplayString(item.description), 1),
              (
                item.description === 'Área privativa' && !_ctx.isBlockedOpportunity
              )
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass(`bi ${item.icon} icon-style`),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleEditView(true)))
                  }, null, 2))
                : (
                item.description === 'Área total construída' &&
                !_ctx.isBlockedOpportunity
              )
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 1,
                      class: _normalizeClass(`bi ${item.icon} icon-style`),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleEditView(false)))
                    }, null, 2))
                  : (!_ctx.isBlockedOpportunity)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 2,
                        class: _normalizeClass(`bi ${item.icon} icon-style`)
                      }, null, 2))
                    : _createCommentVNode("", true)
            ]),
            (item.description === 'Área privativa' && _ctx.showInputAreaPrivativa)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("input", {
                    type: "number",
                    class: _normalizeClass(["m2-slider input-item", { blurred: _ctx.isBlockedOpportunity }]),
                    value: _ctx.areaPriviativaInput,
                    onInput: ($event: any) => (_ctx.updateImovelDataItem($event, index)),
                    onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.showInputAreaPrivativa = false), ["enter"]))
                  }, null, 42, _hoisted_8),
                  _hoisted_9
                ]))
              : (
              item.description === 'Área total construída' &&
              _ctx.showInputAreaConstruida
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("input", {
                      type: "number",
                      class: _normalizeClass(["m2-slider input-item", { blurred: _ctx.isBlockedOpportunity }]),
                      value: _ctx.areaConstruidaInput,
                      onInput: ($event: any) => (_ctx.updateImovelDataItem($event, index)),
                      onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.showInputAreaConstruida = false), ["enter"]))
                    }, null, 42, _hoisted_11),
                    _hoisted_12
                  ]))
                : (item.value !== 'Insira um valor')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["h20", { blurred: _ctx.isBlockedOpportunity }])
                    }, [
                      _createElementVNode("h6", _hoisted_13, _toDisplayString(item.value), 1)
                    ], 2))
                  : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              (item.value === 'Insira um valor')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("h6", _hoisted_17, _toDisplayString(item.value), 1),
                      _createElementVNode("i", {
                        class: _normalizeClass(`bi bi-pencil icon-style`),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleInputNumberEdit())),
                        style: {"margin-left":"5px"}
                      })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      (_ctx.showInputNumber)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "text",
                            class: _normalizeClass(["m2-slider input-item mt-1", { blurred: _ctx.isBlockedOpportunity }]),
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputNumberValue) = $event)),
                            onKeydown: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.formatAndSetRawInputValue && _ctx.formatAndSetRawInputValue(...args)), ["enter"]))
                          }, null, 34)), [
                            [_vModelText, _ctx.inputNumberValue]
                          ])
                        : (_openBlock(), _createElementBlock("h6", _hoisted_20, _toDisplayString(_ctx.inputNumberValue), 1))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (index === 0 && _ctx.showInput && item.value !== 'Insira um valor')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    type: "number",
                    class: _normalizeClass(["m2-slider lcts-card-calc-item-input", { blurred: _ctx.isBlockedOpportunity }]),
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.rawInputValue) = $event))
                  }, null, 2)), [
                    [_vModelText, _ctx.rawInputValue]
                  ])
                : _createCommentVNode("", true),
              (item.showSlider && _ctx.isGroundCoasts)
                ? (_openBlock(), _createBlock(_component_Slider, {
                    key: 2,
                    label: _ctx.label,
                    min: item.startValue,
                    max: item.endValue,
                    step: _ctx.step,
                    value: _ctx.value,
                    onSliderValue: _ctx.handleSliderValue,
                    scaleSize: _ctx.scaleSize,
                    "show-as-number": _ctx.showAsNumber,
                    showAsPercentual: item.showAsPercentual,
                    isBlockedOpportunity: _ctx.isBlockedOpportunity
                  }, null, 8, ["label", "min", "max", "step", "value", "onSliderValue", "scaleSize", "show-as-number", "showAsPercentual", "isBlockedOpportunity"]))
                : _createCommentVNode("", true),
              (_ctx.isIndirectCoasts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_Slider, {
                      label: _ctx.label,
                      min: item.startValue,
                      max: item.endValue,
                      step: _ctx.step,
                      value: Number(item.value),
                      onSliderValue: ($event: any) => (_ctx.handleSliderValueIndirectCoast($event, index)),
                      scaleSize: _ctx.scaleSize,
                      "show-as-number": _ctx.showAsNumber,
                      showAsPercentual: true,
                      class: _normalizeClass({ blurred: _ctx.isBlockedOpportunity })
                    }, null, 8, ["label", "min", "max", "step", "value", "onSliderValue", "scaleSize", "show-as-number", "class"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2))
      }), 128))
    ])
  ]))
}